module.exports = __webpack_public_path__ + "img/class_b.bdb98dbd.png";